import styled from 'styled-components';

interface modalBodyProps {
	bodyScroll?: boolean;
	dFlex?: boolean;
	overFlowAuto?: boolean;
	alignCenter?: boolean;
	justifyContentCenter?: boolean;
	padding?: string;
	marginBottom?: string;
	textAlign?: string;
	minHeight?: string;
}

const ModalBody = styled.div<modalBodyProps>`
	padding: 20px 25px;
	padding: ${({ padding }) => padding};
	margin-bottom: ${({ marginBottom }) => marginBottom}!important;
	text-align: ${({ textAlign }) => textAlign}!important;
	min-height: ${({ minHeight }) => minHeight};
	${({ overFlowAuto }) => overFlowAuto && `overflow: auto; `}
	${({ bodyScroll }) =>
		bodyScroll &&
		`min-height:55vh;
		max-height:55vh;
		overflow: auto;
	`}
	${({ dFlex }) =>
		dFlex &&
		`display: flex;
	`}
	${({ alignCenter }) =>
		alignCenter &&
		`align-items: center;
	`}
	${({ justifyContentCenter }) =>
		justifyContentCenter &&
		`justify-content: center;
	`}
`;

export default ModalBody;
